"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
let internal = exports.internal = id => "@@saga-resources/" + id;
let isInternal = exports.isInternal = id => /^@@saga-resources\//.test(id);
//# sourceMappingURL=internal.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/utils/internal.js